import { useMemo } from "react";

import useTableSort from "components/Table/useTableSort";

import {
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
  MODULE_VERSION_OUTPUTS_TABLE_FILTERS_STORAGE_KEY,
  SORT_CONFIG,
} from "./constants";
import { sortModuleVersionOutputs } from "./helpers";
import { ModuleVersionOutputRow } from "./types";

export const useSortingModuleVersionOutputs = (outputs: ModuleVersionOutputRow[] = []) => {
  const { sortDescriptor } = useTableSort({
    filtersOrderSettingsKey: MODULE_VERSION_OUTPUTS_TABLE_FILTERS_STORAGE_KEY,
    sortConfig: SORT_CONFIG,
    initialSortOption: INITIAL_SORT_OPTION,
    initialSortDirection: INITIAL_SORT_DIRECTION,
  });

  return useMemo(
    () => sortModuleVersionOutputs(outputs, sortDescriptor),
    [outputs, sortDescriptor]
  );
};
